namespace GeniuzPOS.Inventory {
    export interface IcStockTransferForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: GrLookupforTFcustom;
        ConcatRefDocNo2: Serenity.StringEditor;
        WhsIdFm: LookupUserWhs;
        ConcatWhsIdFm: Serenity.StringEditor;
        WhsIdTo: Serenity.LookupEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        Remark: Serenity.TextAreaEditor;
        TransferDtList: IcStockTransferDtEditor;
    }

    export class IcStockTransferForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockTransfer';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockTransferForm.init)  {
                IcStockTransferForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = GrLookupforTFcustom;
                var w3 = LookupUserWhs;
                var w4 = s.LookupEditor;
                var w5 = s.EnumEditor;
                var w6 = s.TextAreaEditor;
                var w7 = IcStockTransferDtEditor;

                Q.initFormType(IcStockTransferForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w0,
                    'RefDocNo2', w2,
                    'ConcatRefDocNo2', w0,
                    'WhsIdFm', w3,
                    'ConcatWhsIdFm', w0,
                    'WhsIdTo', w4,
                    'PostFg', w5,
                    'CancelFg', w5,
                    'Remark', w6,
                    'TransferDtList', w7
                ]);
            }
        }
    }
}
